import styled, { keyframes } from 'styled-components';

import { mediaQuery } from '../../../../../styles/global';

const HeroTextKeyframe = keyframes`
  0% {
    opacity: 0;
    top: 20px;
   }
  100% {
    opacity: 1;
    top: 0;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  text-align: center;
  width: 520px;
  height: 65px;
  align-items: flex-start;
  position: relative;
  margin: 20px 0;
  gap: 15px;
  opacity: 0;
  animation: ${HeroTextKeyframe};
  animation-delay: 1s;
  animation-duration: 1500ms;
  animation-fill-mode: forwards;

  ${mediaQuery.maxWidth.desktop} {
    justify-content: center;
    align-items: center;
    margin-bottom: 40px;
  }

  ${mediaQuery.maxWidth.tablet} {
    flex-direction: column;
    width: 260px;
  }
`;

export const Button = styled.div`
  ${mediaQuery.maxWidth.tablet} {
    margin-top: 10px;
  }
`;

export const PlayButtonText = styled.div`
  margin: 0 0.5rem;
  display: flex;
`;


